module.exports = __webpack_public_path__ + "img/sus-window-img.4f41cf5a.png";